import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {KongService} from '../../kong.service';
import {AccountInfoService} from '../../user/account-info.service';
import {LeftpanelNewComponent} from '../../leftpanel-new/leftpanel-new.component';
import {FormControl, FormGroup} from '@angular/forms';
import {CreateConsumerDialogComponent} from './create-consumer-dialog/create-consumer-dialog.component';

@Component({
  selector: 'app-admin-consumers',
  templateUrl: './admin-consumers.component.html',
  styleUrls: ['./admin-consumers.component.scss']
})
export class AdminConsumersComponent implements OnInit {

  constructor(private kongService: KongService,
              public accountInfoService: AccountInfoService,
              public dialog: MatDialog,
              public platform: LeftpanelNewComponent) {
  }
  selectedConsumer: any;
  consumerList = [];
  consumerResponse: any;
  username: any;
  customId: any;
  tag: any;
  consumerId: any;
  basicReponse = [];
  apiKeyResponse = [];
  oauthResponse = [];
  hmacResponse = [];
  jwtResponse = [];
  groupResponse: any;
  selectedTabIndex: any;
  partnerName: any;
  selectedCredentialTabIndex = 0;
  profileForm = new FormGroup({
    username: new FormControl(''),
    custom_id: new FormControl(''),
    tags: new FormControl('')
  });
  searchText: any;
  signInEmail: any;
  createCredentialDialogData: any;
  displayedColumns = {
    displayedColumnsAPIKey: ['index', 'key', 'created', 'action'],
    displayedColumnsBasic: ['index', 'username', 'password', 'created', 'action'],
    displayedColumnsHMAC: ['index', 'username', 'secret', 'created', 'action'],
    displayedColumnsOAuth: [
      'name',
      'clientID',
      'redirectURLs',
      'created',
      'action',
    ],
    displayedColumnsJWT: [
      'index',
      'jwtResponse',
      'created',
      'action',
    ]
  };


  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.signInEmail = localStorage.getItem('signInEmail');
    this.getInitialKongConsumerDetails(localStorage.getItem('partner'), this.signInEmail);
  }

  getIndex(element: any, array: any) {
    return array.findIndex(res => res === element);
  }

  onConsumerSelected(consumer: any) {
    this.selectedConsumer = consumer;
  }

  viewJWT(jwtResponse: any) {
    const dialogRef = this.dialog.open(CreateConsumerDialogComponent, {
      data: {
        Topic: 'JWT Response',
        type: 'jwt-response',
        jwtResponse: jwtResponse,
        attributes: [],
        id: this.consumerId,
        partnerName: this.partnerName
      },
      width: '30%',
      panelClass: 'dialog-color'
    });
  }

  getInitialAssingedKongConsumerDetails(partnerName) {
    this.consumerList = [];
    this.kongService.getAssignedKongConsmers(partnerName).subscribe((data) => {
      this.consumerList = data['data'];
      this.tag.push(partnerName);
      if (data['data'].length < 1) {
        const payload = {
          tags: this.tag
        };
        this.kongService.patchTagToConsumer(this.consumerId, payload).subscribe((patchResult) => {
          this.consumerList = [];
          this.kongService.getAssignedKongConsmers(partnerName).subscribe((result) => {
            this.consumerList = result['data'];
          });
        });
      }
    });
  }

  getInitialKongConsumerDetails(username, emailId) {

    this.consumerResponse = null;
    this.kongService.getKongGatewayConsumerDetails(emailId).subscribe((data) => {
      this.consumerResponse = data['data'][0];
      const temp = username.split('-');
      const pName = temp[temp.length - 1];
      if (data['data'].length > 0) {

        this.username = this.consumerResponse['username'];
        this.customId = this.consumerResponse['custom_id'];
        this.consumerId = this.consumerResponse['id'];
        this.tag = this.consumerResponse['tags'];
        this.getInitialAssingedKongConsumerDetails(pName);
        this.getKongCredentialDetails('key-auth');
      } else {
        const temp = username.split('-');
        this.partnerName = temp[temp.length - 1];
        this.kongService.getKongGatewayConsumerDetails(this.signInEmail).subscribe((data) => {
          this.consumerResponse = data['data'][0];
          if (data['data'].length > 0) {
            this.username = this.consumerResponse['username'];
            this.customId = this.consumerResponse['custom_id'];
            this.consumerId = this.consumerResponse['id'];
            this.tag = this.consumerResponse['tags'];
            this.getInitialAssingedKongConsumerDetails(this.partnerName);
            this.getKongCredentialDetails('key-auth');
          }
        });
      }
    });

  }

  getKongConsumerDetails(username, emailId) {
    this.consumerResponse = null;
    const temp = username.split('-');
    this.partnerName = temp[temp.length - 1];
    this.kongService.getKongGatewayConsumerDetails(emailId).subscribe((data) => {
      this.consumerResponse = data['data'][0];
      if (data['data'].length > 0) {
        this.username = this.consumerResponse['username'];
        this.customId = this.consumerResponse['custom_id'];
        this.consumerId = this.consumerResponse['id'];
        this.tag = this.consumerResponse['tags'];
        this.getKongCredentialDetails('key-auth');
      }
    });
  }

  deletKongConsumer(id, topic) {
    if (confirm('This action is irreversible, Are you sure you want to delete this ' + topic + ' credential?')) {
      this.kongService.deletKongConsumer(id).subscribe(data => {
        this.getInitialKongConsumerDetails(localStorage.getItem('partner'), this.signInEmail);
      });
    }
  }

  getKongCredentialDetails(type) {
    this.kongService.getKongGatewayCredentialDetails(type, this.consumerId).subscribe((data) => {
      switch (type) {
        case 'basic-auth':
          this.basicReponse = [];
          this.basicReponse = data['data'];
          break;
        case 'key-auth':
          this.apiKeyResponse = [];
          this.apiKeyResponse = data['data'];
          break;
        case 'hmac-auth':
          this.hmacResponse = [];
          this.hmacResponse = data['data'];
          break;
        case 'oauth2':
          this.oauthResponse = [];
          this.oauthResponse = data['data'];
          break;
        case 'jwt':
          this.jwtResponse = [];
          this.jwtResponse = JSON.parse(JSON.stringify(data['data']));
          break;
        case 'acls':
          this.groupResponse = [];
          this.groupResponse = data['data'];
          break;
      }
    });

  }

  stringifyjson(val) {
    if (val != null) {
      return JSON.stringify(val, null, 2).trim();
    } else {
      return val;
    }
  }

  openDialog(type): void {

    switch (type) {
      case'basic':
        this.createCredentialDialogData = {
          Topic: 'Basic Auth',
          type: 'basic-auth',
          attributes: [
            {
              displayName: 'UserName',
              name: 'username',
              description: 'The username to use in the Basic Authentication',
              option: 'required'
            },
            {
              displayName: 'Password',
              name: 'password',
              description: 'The password to use in the Basic Authentication',
              option: 'required'
            }
          ],
          id: this.consumerId,
          partnerName: this.partnerName
        };
        break;
      case'apiKey':
        this.createCredentialDialogData = {
          Topic: 'Create API Key',
          type: 'key-auth',
          attributes: [
            {
              displayName: 'Key',
              name: 'key',
              description: 'You can optionally set your own unique key to authenticate the client. If missing, Kong will generate one.',
              option: 'optional'
            }
          ],
          id: this.consumerId,
          partnerName: this.partnerName
        };
        break;
      case'hmac':
        this.createCredentialDialogData = {
          Topic: 'HMAC Auth',
          type: 'hmac-auth',
          attributes: [
            {
              displayName: 'Username',
              name: 'username',
              description: 'The username to use in the HMAC Signature verification',
              option: 'required'
            },
            {
              displayName: 'Secret',
              name: 'secret',
              description: 'The secret to use in the HMAC Signature verification',
              option: 'optional'
            }
          ],
          id: this.consumerId,
          partnerName: this.partnerName
        };
        break;
      case 'oauth':
        this.createCredentialDialogData = {
          Topic: 'Create OAUTH ',
          type: 'oauth2',
          attributes: [
            {
              displayName: 'Name',
              name: 'name',
              description: 'The name to associate to the credential. In OAuth 2.0 this would be the application name.',
              option: 'required'
            },
            {
              displayName: 'Client ID',
              name: 'client_id',
              description: 'You can optionally set your own unique client_id. If missing, the plugin will generate one.',
              option: 'optional'
            },
            {
              displayName: 'Client Secret',
              name: 'client_secret',
              description: 'You can optionally set your own unique client_secret. If missing, the plugin will generate one.',
              option: 'optional'
            },
            {
              displayName: 'Redirect URIs',
              name: 'redirect_uris',
              description: 'The URL in your app where users will be sent after authorization (RFC 6742 Section 3.1.2)',
              option: 'required'
            }
          ],
          id: this.consumerId,
          partnerName: this.partnerName
        };
        break;
      case 'jwt':
        this.createCredentialDialogData = {
          Topic: 'Create JWT',
          type: 'jwt',
          attributes: [
            {
              displayName: 'Key',
              name: 'key',
              description: 'A unique string identifying the credential. If left out, it will be auto-generated. However, usage of this key is mandatory while crafting your token, as specified in the next section.',
              option: 'optional',
            },
            {
              displayName: 'Algorithm',
              name: 'algorithm',
              description: 'The algorithm used to verify the token\'s signature. Can be HS256 or RS256.',
              option: 'required'
            },
            {
              displayName: 'RSA Public Key',
              name: 'rsa_public_key',
              description: 'If algorithm is RS256, the public key (in PEM format) to use to verify the token\'s signature.',
              option: 'optional'
            },
            {
              displayName: 'Secret',
              name: 'secret',
              description: 'If algorithm is HS256, the secret used to sign JWTs for this credential. If left out, will be auto-generated. If algorithm is RS256, this is the private key (in PEM format) to use to verify the token\'s signature.',
              option: 'optional'
            }
          ],
          id: this.consumerId,
          partnerName: this.partnerName
        };
        break;
      case 'group':
        this.createCredentialDialogData = {
          Topic: 'Add Group',
          type: 'acls',
          attributes: [
            {
              displayName: 'Group Name',
              name: 'Group name',
              description: 'The name of the ACL group.',
              option: 'required'
            }
          ],
          id: this.consumerId,
          partnerName: this.partnerName
        };
        break;
      case 'consumer' :
        this.createCredentialDialogData = {
          Topic: 'Create Consumer',
          type: 'consumer',
          attributes: [
            {
              displayName: 'Email',
              name: 'username',
              description: 'Email of the consumer. You must send either this field or username with the request.',
              option: 'semi-optional'
            },
            {
              displayName: 'Tags',
              name: 'tags',
              description: 'Optionally add tags to the consumer',
              option: 'optional'
            }
          ],
          id: this.consumerId,
          partnerName: this.partnerName
        };
        break;
    }

    const dialogRef = this.dialog.open(CreateConsumerDialogComponent, {
      data: this.createCredentialDialogData,
      width: '50%',
      panelClass: 'dialog-color'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== '') {
        if (result === 'consumers') {
          const temp = localStorage.getItem('partner').split('-');
          this.getInitialAssingedKongConsumerDetails(temp[temp.length - 1]);
        } else {
          this.getKongCredentialDetails(result);
        }

      }
    });
  }

  delete(id, type, topic) {

    if (confirm('This action is irreversible, Are you sure you want to delete this ' + topic + ' credential?')) {
      this.kongService.deleteKongGatewayConsumerCredential(this.consumerId, type, id).subscribe(data => {
        this.getKongCredentialDetails(type);
      });
    }
  }

  tabChanged(event) {
    if (event.index === 1) {
      this.selectedTabIndex = 1;
      this.getKongCredentialDetails('acls');
    } else if (event.index === 0) {
      this.selectedTabIndex = 0;
      this.getKongCredentialDetails('key-auth');
      this.selectedCredentialTabIndex = 0;
    }
  }

  credentialTabChange(event) {
    switch (event.index) {
      case 0:
        this.selectedCredentialTabIndex = 0;
        this.getKongCredentialDetails('key-auth');
        break;
      case 1:
        this.selectedCredentialTabIndex = 1;
        this.getKongCredentialDetails('basic-auth');
        break;
      case 2:
        this.selectedCredentialTabIndex = 2;
        this.getKongCredentialDetails('hmac-auth');
        break;
      case 3:
        this.selectedCredentialTabIndex = 3;
        this.getKongCredentialDetails('oauth2');
        break;
      case 4:
        this.selectedCredentialTabIndex = 4;
        this.getKongCredentialDetails('jwt');
        break;
    }
  }

  loadKongDetail(username, emailId) {
    this.getKongConsumerDetails(username, emailId);
    this.credentialTabChange({index: 0});
    this.tabChanged({index: 0});
    // this.selectedTabIndex = 0;
  }

}
